// extracted by mini-css-extract-plugin
export var ForumTagCard__title = "ForumTagCard__title_R2Chw";